import { AppBar } from '@components/AppBar';
import { Typography } from '@mui/material';

export const SystemError = function () {
  return <>
    <AppBar/>
    <Typography variant={"h4"} style={{ textAlign: "center" }}>系統錯誤，請重新整理此頁面</Typography>
  </>
}
